/**
 * SearchService - Ermöglicht die Kommunikation zwischen Sidebar-Suche und Market-Komponente
 * 
 * Implementiert ein einfaches Publish/Subscribe-Pattern für die Übermittlung von Suchbegriffen
 * und Filtereinstellungen zwischen den verschiedenen Komponenten.
 */

class SearchService {
  constructor() {
    this.listeners = {
      searchTerm: [],
      filters: []
    };
    this.currentSearchTerm = '';
    this.currentFilters = {
      setCategories: []
    };
  }

  /**
   * Setzt den aktuellen Suchbegriff und informiert alle Abonnenten
   * @param {string} term - Der Suchbegriff
   */
  setSearchTerm(term) {
    this.currentSearchTerm = term;
    this._notifyListeners('searchTerm', term);
  }

  /**
   * Setzt die aktuellen Filter und informiert alle Abonnenten
   * @param {Object} filters - Die Filteroptionen
   */
  setFilters(filters) {
    this.currentFilters = { ...filters };
    this._notifyListeners('filters', this.currentFilters);
  }

  /**
   * Gibt den aktuellen Suchbegriff zurück
   * @returns {string} - Der aktuelle Suchbegriff
   */
  getSearchTerm() {
    return this.currentSearchTerm;
  }

  /**
   * Gibt die aktuellen Filter zurück
   * @returns {Object} - Die aktuellen Filter
   */
  getFilters() {
    return { ...this.currentFilters };
  }

  /**
   * Registriert einen Listener für Änderungen am Suchbegriff
   * @param {Function} callback - Die Callback-Funktion, die bei Änderungen aufgerufen wird
   * @returns {Function} - Eine Funktion zum Abmelden des Listeners
   */
  subscribeToSearchTerm(callback) {
    this.listeners.searchTerm.push(callback);
    return () => {
      this.listeners.searchTerm = this.listeners.searchTerm.filter(
        cb => cb !== callback
      );
    };
  }

  /**
   * Registriert einen Listener für Änderungen an den Filtern
   * @param {Function} callback - Die Callback-Funktion, die bei Änderungen aufgerufen wird
   * @returns {Function} - Eine Funktion zum Abmelden des Listeners
   */
  subscribeToFilters(callback) {
    this.listeners.filters.push(callback);
    return () => {
      this.listeners.filters = this.listeners.filters.filter(
        cb => cb !== callback
      );
    };
  }

  /**
   * Private Methode zum Benachrichtigen aller Listener
   * @param {string} type - Der Typ der Benachrichtigung ('searchTerm' oder 'filters')
   * @param {*} data - Die Daten, die an die Listener übermittelt werden sollen
   * @private
   */
  _notifyListeners(type, data) {
    if (this.listeners[type]) {
      this.listeners[type].forEach(callback => callback(data));
    }
  }

  /**
   * Löscht alle Filter und den Suchbegriff
   */
  clearAll() {
    this.currentSearchTerm = '';
    this.currentFilters = {};
    this._notifyListeners('searchTerm', '');
    this._notifyListeners('filters', {});
  }
}

// Singleton-Instanz des SearchService
const searchService = new SearchService();
export default searchService;
